import { render } from "./gsgy.vue?vue&type=template&id=07b70bd5&scoped=true&ts=true"
import script from "./gsgy.vue?vue&type=script&lang=ts"
export * from "./gsgy.vue?vue&type=script&lang=ts"

import "./gsgy.vue?vue&type=style&index=0&id=07b70bd5&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b70bd5"]])

export default __exports__